const Menu =  [
  { header: 'Apps' },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    dispatch:'fetchFriends'
  },


  { divider: true },
  {
    title: 'Membres',
    group: 'widgets',
    component: 'widgets',
    icon: 'widgets',
    dispatch:'fetchMembers',
    items: [
      { name: 'allmembers', title: 'Membres Total', component: 'components/widget-allmembers' , dispatch:'fetchMembers' },
      { name: 'statistic', title: 'Membres Aujourd\'hui', badge: 'new', component: 'components/widget-todaylist',  dispatch:'fetchMembers' },
      { name: 'chart', title: 'Serviteurs', component: 'components/widget-serviteurs' , dispatch:'fetchMembers' },
      { name: 'list', title: 'Donnés Vides', component: 'components/widget-empty-list' , dispatch:'fetchMembers' },
      { name: 'referrals', title: 'Références', component: 'components/widget-referrals' , dispatch:'fetchMembers' },
      { name: 'search', title: 'Recherche', component: 'components/widget-search'  , dispatch:'fetchMembers' },
     
    ]
  },
/*   {
    title: 'Bénévolats',
    group: 'apps',
    icon: 'supervised_user_circle',
    name: 'Benevolats',
    dispatch:''
  }, */
  {
    title: 'Employés',
    group: 'apps',
    name: 'Employees',
    icon: 'people',
    dispatch: 'fetchEmployees'
  },
  {
    title: 'Providers',
    group: 'providers',
    component: 'providers',
    icon: 'signal_cellular_alt',
    items: [
      { name: 'vodaphone', title: 'Vodaphone', component: 'components/providers-vodaphone', dispatch:'fetchMembers' },
      { name: 'orange_tigo', title: 'Orange & Tigo', component: 'components/providers-orange_tigo', dispatch:'fetchMembers' },
      { name: 'airtel', title: 'Airtel', component: 'components/providers-airtel', dispatch:'fetchMembers' },
      { name: 'africell', title: 'Africell', component: 'components/providers-africell', dispatch:'fetchMembers' },
      { name: 'others', title: 'Autres', component: 'components/providers-others', dispatch:'fetchMembers' },
    ]
  },  
/*   {
    title: 'Messages',
    group: 'messages',
    component: 'messages',
    icon: 'message',
    items: [
      { name: 'Chat', title: 'Mes messages', component: 'Chat' },
      { name: 'Chat', title: 'Au serviteurs', component: 'Chat' },
      { name: 'orange_tigo', title: 'À une paroisse', component: 'components/providers-orange_tigo' },
      { name: 'airtel', title: 'À un membre specific', component: 'components/providers-airtel' },
      { name: 'Prière', title: 'Prière du jour', component: 'widget-post' },
    ]
  },   */
  { divider: true },
  { header: 'Community' },
  {
    title: 'Projets',
    group: 'apps',
    icon: 'build',
    name: 'widget-projects',
    dispatch:'fetchProjects'
  },
  {
    title: 'Chat',
    group: 'apps',
    icon: 'chat_bubble',
    name: 'widget-chat',
    dispatch:'fetchConvos'
  },
  {
    title: 'Medias',
    group: 'apps',
    icon: 'perm_media',
    name: 'widget-medias',
    dispatch:'fetchMedias'
  },
  {
    title: 'Merchants',
    group: 'apps',
    icon: 'account_balance',
    name: 'widget-merchants',
    dispatch:'fetchMerchants'
  },
  {
    title: 'Coupons',
    group: 'apps',
    icon: 'local_atm',
    name: 'widget-coupons',
    dispatch:'fetchCoupons'
  },
  {
    title: 'Events',
    group: 'apps',
    icon: 'event',
    name: 'widget-events',
    dispatch:'fetchEvents'
  },
  {
    title: 'Postes',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-post',
    dispatch:'fetchJobs'
  },
  {
    title: 'Prayers',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-prayers',
    dispatch:'fetchPrayers'
  },
/*   {
    title: 'Commerces',
    group: 'apps',
    icon: 'shopping_cart',
    name: 'widget-merchants',
    dispatch:''
  }, */
/*   {
    title: 'Backers',
    group: 'apps',
    icon: 'recent_actors',
    name: 'widget-backers',
    dispatch:''
  }, */
/*   {
    title: 'Nouvelles donées',
    group: 'forms',
    component: 'forms',
    icon: 'add_circle',
    items: [
      { name: 'newmember', title: 'Nouveau membre', component: 'components/newmember' },
      { name: 'newproject', title: 'Nouveau projet', component: 'components/newproject' },
      // { name: 'basic', title: 'General', component: 'components/basic-forms' },
      // { name: 'selects', title: 'Selects', badge: 'new', component: 'components/selects' },
      // { name: 'selection-controls', title: 'Selection Controls', component: 'components/selection-controls' },
      // { name: 'text-fields', title: 'Text Fields', component: 'components/text-fields' },
      { name: 'newemployee', title: 'Nouveau employé', component: 'components/newemployee' },
      // { name: 'editors', title: 'Editors', component: 'components/editors' },
    ]
  }, */
  // { divider: true },
  // { header: 'Extras' },
  // {
  //   title: 'Pages',
  //   group: 'extra',
  //   icon: 'list',
  //   items: [
  //     { name: 'Login', title: 'Login', component: 'Login' },
  //     { name: '404', title: '404', component: 'NotFound' },
  //     { name: '403', title: '403', component: 'AccessDenied' },
  //     { name: '500', title: '500', component: 'ServerError' },
  //   ]
  // },
];

const CMenu =  [
  { header: 'Apps' },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
  },
  { divider: true },
  {
    title: 'Membres',
    group: 'widgets',
    component: 'widgets',
    icon: 'widgets',
    items: [
      { name: 'allmembers', title: 'Membres Total', component: 'components/widget-allmembers' },
      { name: 'statistic', title: 'Membres Aujourd\'hui', badge: 'new', component: 'components/widget-todaylist' },
      { name: 'chart', title: 'Serviteurs', component: 'components/widget-serviteurs' },
      { name: 'list', title: 'Donnés Vides', component: 'components/widget-empty-list' },
      { name: 'referrals', title: 'Références', component: 'components/widget-referrals' }
    ]
  },
  {
    title: 'Messages',
    group: 'messages',
    component: 'messages',
    icon: 'message',
    items: [
      { name: 'Chat', title: 'Au serviteurs', component: 'Chat' },
      { name: 'Paroisse', title: 'À une paroisse', component: 'components/providers-orange_tigo' },
      { name: 'Membre', title: 'À un membre specific', component: 'components/providers-airtel' },
      { name: 'Prière', title: 'Prière du jour', component: '/widget-post' },
    ]
  },  
  { divider: true },
  {
    title: 'Nouvelles donées',
    group: 'forms',
    component: 'forms',
    icon: 'add_circle',
    items: [
      { name: 'newmember', title: 'Nouveau membre', component: '/forms/newmember' },
      { name: 'newproject', title: 'Nouveau projet', component: 'forms/newproject' },
      // { name: 'basic', title: 'General', component: 'components/basic-forms' },
      // { name: 'selects', title: 'Selects', badge: 'new', component: 'components/selects' },
      // { name: 'selection-controls', title: 'Selection Controls', component: 'components/selection-controls' },
      // { name: 'text-fields', title: 'Text Fields', component: 'components/text-fields' },
      { name: 'newemployee', title: 'Nouveau employé', component: 'forms/newemployee' },
      // { name: 'editors', title: 'Editors', component: 'components/editors' },
    ]
  }
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js